<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <div class="p-7 space-y-5">
    <div class="flex items-start justify-between mb-4 flex-wrap gap-2">
      <div class="flex items-start gap-2.5">
        <div
          class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
        >
          <igntr-icon name="users"></igntr-icon>
        </div>
        <div>
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ "teams" | transloco }}
          </div>
          <div class="text-[12px] !text-slate-500 mt-0.5">
            {{ teams.length }} {{ "teams" | transloco }}
          </div>
        </div>
      </div>
      <div class="flex items-center gap-3 justify-end">
        <input
          type="text"
          [(ngModel)]="newTeamText"
          placeholder="{{ 'enterTeamName' | transloco }}"
          class="w-50 text-[14px] !text-slate-800 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 ng-untouched ng-pristine ng-valid bg-[white]"
        />
        <button
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium inline-flex items-center gap-1.5"
          (click)="addTeam()"
        >
          <igntr-icon name="plus"></igntr-icon>
          {{ "newTeam" | transloco }}
        </button>
      </div>
    </div>

    <div
      class="rounded-xl border !border-slate-200/70 bg-white divide-y divide-slate-100"
      *ngIf="teams.length > 0"
    >
      <div
        class="flex items-center gap-3 px-3.5 py-3"
        *ngFor="let team of teams; let i = index"
      >
        <div
          class="w-8 h-8 rounded-lg bg-slate-100 !text-slate-600 flex items-center justify-center"
          style="background: oklch(0.85 0.1 30)"
        >
          <igntr-icon name="users"></igntr-icon>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ team.name }}
          </div>
          <!-- <div class="text-[14px] !text-slate-500">Lead · Mads Winther</div> -->
        </div>
        <!-- <div class="-space-x-1.5 hidden md:flex">
          <div
            class="w-6 h-6 rounded-full border-2 border-white text-[14px] font-semibold flex items-center justify-center !text-slate-700"
            style="background: oklch(0.92 0.04 0)"
          >
            A
          </div>
          <div
            class="w-6 h-6 rounded-full border-2 border-white text-[14px] font-semibold flex items-center justify-center !text-slate-700"
            style="background: oklch(0.92 0.04 70)"
          >
            B
          </div>
          <div
            class="w-6 h-6 rounded-full border-2 border-white text-[14px] font-semibold flex items-center justify-center !text-slate-700"
            style="background: oklch(0.92 0.04 140)"
          >
            C
          </div>
          <div
            class="w-6 h-6 rounded-full border-2 border-white text-[14px] font-semibold flex items-center justify-center !text-slate-700"
            style="background: oklch(0.92 0.04 210)"
          >
            D
          </div>
        </div> -->
        <!-- <span
          class="font-mono text-[11px] !text-slate-500 tabular-nums w-10 text-right"
          >6</span
        > -->
        <button
          class="!text-slate-400 hover:!text-slate-700"
          [matMenuTriggerFor]="menu"
        >
          <igntr-icon name="dots"></igntr-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            class="text-danger"
            (click)="deleteConfirmation = team"
            title="{{ 'delete' | transloco }}"
          >
            {{ "delete" | transloco }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
<!-- 
<div class="tenant-tags-container mt-4">
  <h2>Tenant Teams</h2>

  <div class="mb-2">
    <input
      type="text"
      pInputText
      [(ngModel)]="newTeamText"
      placeholder="Enter team name"
      class="tag-input"
    />
    <button
      pButton
      type="button"
      icon="pi pi-plus"
      (click)="addTeam()"
      class="ms-2"
    ></button>
  </div>

  <p-table
    #dt1
    [value]="teams"
    class="p-0"
    [globalFilterFields]="['name', 'description']"
  >
    <ng-template pTemplate="header">
      <tr>
        <th [attr.colspan]="innerWidth < 1200 ? 2 : 1">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-search"></i>
            </p-inputgroup-addon>
            <input
              type="text"
              pInputText
              (input)="onGlobalFilter(dt1, $event)"
              placeholder="{{ 'search' | transloco }}"
            />
          </p-inputgroup>
        </th>
        <th class="d-none d-xl-table-cell"></th>
      </tr>
      <tr>
        <th pSortableColumn="title" class="col-6 col-xl-3">
          {{ "title" | transloco }} <p-sortIcon field="title"></p-sortIcon>
        </th>
        <th pSortableColumn="createdAt" class="col-5 col-xl-2">
          {{ "created" | transloco }}
          <p-sortIcon field="createdAt"></p-sortIcon>
        </th>
        <th class="col-1"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-team>
      <tr>
        <td>{{ team.name }}</td>
        <td>{{ team.createdAt | date: "dd-MM-yyyy" }}</td>
        <td>
          <div style="display: flex; justify-content: end">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              tabindex="-1"
              class="small-icon-button d-flex justify-content-center align-items-center p-0"
              style="width: 32px; height: 32px; font-size: 20px; line-height: 1"
            >
              <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                class="text-danger"
                (click)="deleteConfirmation = team"
                title="{{ 'delete' | transloco }}"
              >
                {{ "delete" | transloco }}
              </button>
            </mat-menu>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div> -->
<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConfirmation"
  [deleteCandidate]="deleteConfirmation.name"
  (confirm)="handleDeleteClick(deleteConfirmation); deleteConfirmation = null"
  (cancel)="deleteConfirmation = null"
></app-confirm-delete>
